























import { VesselComparisonMode } from "@/types/vesselComparison";
import { Component, Model, Vue } from "vue-property-decorator";

@Component
export default class VesselComparisonViewToggle extends Vue {
  @Model("update:modelValue") mode!: VesselComparisonMode;

  onModeChange(newMode: string) {
    this.$emit("update:modelValue", newMode);
  }
}
